module.exports = __webpack_public_path__ + "media/dashboard/assets/images/like-75f9bea19bc19b9c135680982ab818e9.svg";